// Use fixed page categories rather than survey content or document titles.
function titleForPath(path: string): string {
  if (path === '/') return 'Landing'
  if (path === '/try') return 'Guest builder (try)'
  if (path === '/login') return 'Log in'
  if (path === '/register') return 'Sign up'
  if (path === '/forgot-password') return 'Forgot password'
  if (path.startsWith('/surveys/new') || path.startsWith('/builder/new')) return 'New survey'
  if (path.includes('/results')) return 'Survey results'
  if (path.includes('/edit')) return 'Survey editor'
  if (path === '/surveys') return 'My surveys'
  if (path.startsWith('/s/') || path.startsWith('/respond/')) return 'Respond to survey'
  if (path.includes('/thank-you')) return 'Thank you'
  if (path === '/profile') return 'Profile'
  if (path === '/settings') return 'Settings'
  if (path === '/help') return 'Help'
  if (path === '/templates') return 'Templates'
  return 'Other page'
}

function safeAnalyticsPath(path: string): string {
  const pathname = path.split(/[?#]/)[0]
  if (/^\/(s|respond)\/[^/]+$/.test(pathname)) return pathname.replace(/\/[^/]+$/, '/:surveyId')
  if (/^\/(builder|surveys)\/[^/]+\/(edit|results)$/.test(pathname))
    return pathname.replace(/\/[^/]+\/(edit|results)$/, '/:surveyId/$1')
  if (/^\/survey\/[^/]+\/thank-you$/.test(pathname)) return '/survey/:surveyId/thank-you'
  return [
    '/',
    '/try',
    '/login',
    '/register',
    '/forgot-password',
    '/builder/new',
    '/surveys/new',
    '/surveys',
    '/profile',
    '/settings',
    '/help',
    '/templates',
  ].includes(pathname)
    ? pathname
    : '/other'
}

export function analyticsPageFields(path: string): Record<string, string> {
  const safePath = safeAnalyticsPath(path)
  return {
    page_path: safePath,
    page_location: window.location.origin + safePath,
    page_title: titleForPath(safePath),
    page_referrer: '',
  }
}
